// extracted by mini-css-extract-plugin
export default {"item":"conflict_radios-module___item___e87b11c9","container":"conflict_radios-module___container___cc376d36"};